import axios from "axios"

export interface OnpremiseServerInfo {
  id?: string
  name?: string
  server_id?: string
  server_name?: string
}

export interface OnpremiseServerProject {
  id: string
  name: string
}

export interface OnpremiseServerDeployment {
  id: string
  name: string
}

export interface OnpremiseServerCalibration {
  id: string
  name: string
}

export interface OnpremiseServerProjectsResponse {
  projects: OnpremiseServerProject[]
}

export interface OnpremiseServerDeploymentsResponse {
  deployments: OnpremiseServerDeployment[]
}

export interface OnpremiseServerCalibrationsResponse {
  calibrations: OnpremiseServerCalibration[]
}

export interface OnpremiseServerInfoResponse {
  servers: OnpremiseServerInfo[]
}

const getHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
})

export const onpremiseServerInfoAPI = {
  getServerInfo: async (input: {
    token: string
    apiGatewayUrl: string
    id?: string
    summary?: boolean
  }) => {
    const { token, apiGatewayUrl, id, summary } = input
    const res = await axios.get(
      `${apiGatewayUrl}/onpremiseServerInfo`,
      {
        headers: getHeaders(token),
        params: {
          ...(id && { id }),
          ...(typeof summary === "boolean" && { summary }),
        },
      }
    )
    return res.data as OnpremiseServerInfoResponse | OnpremiseServerInfo[] | OnpremiseServerInfo
  },
  getServerProjects: async (input: {
    token: string
    apiGatewayUrl: string
    serverId: string
  }) => {
    const { token, apiGatewayUrl, serverId } = input
    const res = await axios.get(
      `${apiGatewayUrl}/onpremiseServerInfo/${serverId}/projects`,
      {
        headers: getHeaders(token),
      }
    )
    return res.data as OnpremiseServerProjectsResponse
  },
  getServerProjectDeployments: async (input: {
    token: string
    apiGatewayUrl: string
    serverId: string
    projectId: string
  }) => {
    const { token, apiGatewayUrl, serverId, projectId } = input
    const res = await axios.get(
      `${apiGatewayUrl}/onpremiseServerInfo/${serverId}/projects/${projectId}/deployments`,
      {
        headers: getHeaders(token),
      }
    )
    return res.data as OnpremiseServerDeploymentsResponse
  },
  getServerDeploymentCalibrations: async (input: {
    token: string
    apiGatewayUrl: string
    serverId: string
    deploymentId: string | number
  }) => {
    const { token, apiGatewayUrl, serverId, deploymentId } = input
    const res = await axios.get(
      `${apiGatewayUrl}/onpremiseServerInfo/${serverId}/deployments/${deploymentId}/calibrations`,
      {
        headers: getHeaders(token),
      }
    )
    return res.data as OnpremiseServerCalibrationsResponse
  },
}
